import React from 'react';

const Documentations: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold mb-8 text-center">Documentation</h1>
      <div className="space-y-6">
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Teams Integration</h2>
          <p className="text-gray-700">Learn how to integrate Teams using Adaptive Cards.</p>
          <a
            href="/documentations/teams-integration"
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Teams Integration Docs
          </a>
        </div>
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Slack Integration</h2>
          <p className="text-gray-700">Learn how to integrate Slack for notifications.</p>
          <a
            href="/documentations/slack-integration"
            className="text-blue-600 underline"
          >
            Slack Integration Docs
          </a>
        </div>
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">SMS Integration</h2>
          <p className="text-gray-700">Learn how to set up SMS notifications.</p>
          <a
            href="/documentations/sms-integration"
            className="text-blue-600 underline"
          >
            SMS Integration Docs
          </a>
        </div>
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">API Documentation</h2>
          <p className="text-gray-700">Explore our API documentation for developers.</p>
          <a
            href="/documentations/api-documentation"
            className="text-blue-600 underline"
          >
            API Documentation
          </a>
        </div>
      </div>
    </div>
  );
};

export default Documentations;
